import React, { ReactNode, createContext, useContext, useState } from 'react';

export type AlertRequest = {
  title: string;
  content: string;
  closeText?: string;
  onClose: () => void;
};

export type AlertContextType = {
  isOpen: boolean;
  alertRequest: AlertRequest;
  openAlert: (request: AlertRequest) => void;
  closeAlert: () => void;
};

export const AlertContext = createContext({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  openAlert: (request: AlertRequest) => {},
  closeAlert: () => {},
} as AlertContextType);

export const useAlertContext = () => {
  return useContext(AlertContext);
};

export const AlertProvider = ({ children }: { children: ReactNode }) => {
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  const [alertRequest, setAlertRequest] = useState<AlertRequest>({
    title: '',
    content: '',
    onClose: () => {},
  });

  const openAlert = (request: AlertRequest) => {
    setAlertRequest(request);
    setIsAlertOpen(true);
  };

  const closeAlert = () => {
    alertRequest.onClose();
    setIsAlertOpen(false);
  };

  return (
    <AlertContext.Provider
      value={{
        isOpen: isAlertOpen,
        alertRequest: alertRequest,
        openAlert: openAlert,
        closeAlert: closeAlert,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};
